module.exports = __webpack_public_path__ + "static/media/14.cce7bf9e.jpg";